import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const PROMPT_CLASSES = {
  RecommendationLetterWriterPrompt: 'RecommendationLetterWriterPrompt',
};

/**
 * @param version
 * @param payload
 * Required Body Fields:
 * *payload.prompt_class(string): Worker class of the prompt that'll work on BE
 * *payload.user_prompt(string): Prompt to trigger the job

 * Optional Body Fields
 * model_id(string): ID name of the AI modal that we'd use (won't be changed 99%)
 * system_prompt(string): Custom system prompt
 * max_tokens(number)
 * temperature(float)
 * top_p(float)

 * @returns {fn:generateLLMJobSync}
 */
export const generateLLMJobSync = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/sl-llm/llm-jobs/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const generateLLMJobAsync = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/sl-llm/llm-jobs/create-and-process-async/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getLLMJob = ({ hashId, version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/sl-llm/llm-jobs/${hashId}/`,
      method: RequestMethod.GET,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
